import React, { useMemo } from 'react';
import { Box } from '@mui/material';
import { useSearchParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import ManagementPageLayout from '../../components/layout/ManagementPageLayout';
import FolderTabs from '../../components/common/FolderTabs';
import StoresManagementStoresPanel from '../../components/stores-management/StoresManagementStoresPanel';
import PlanDiscountVouchersPanel from '../../components/stores-management/PlanDiscountVouchersPanel';

const STORES_TAB = 'stores';
const VOUCHERS_TAB = 'vouchers';

const resolveActiveTab = (tabParam) => (tabParam === VOUCHERS_TAB ? VOUCHERS_TAB : STORES_TAB);

const StoresManagementPage = () => {
  const { t } = useTranslation();
  const [searchParams, setSearchParams] = useSearchParams();
  const activeTab = resolveActiveTab(searchParams.get('tab'));

  const tabs = useMemo(() => ([
    { value: STORES_TAB, label: t('storesManagement.tabs.stores') },
    { value: VOUCHERS_TAB, label: t('storesManagement.tabs.vouchers') },
  ]), [t]);

  const handleTabChange = (nextTab) => {
    setSearchParams(nextTab === STORES_TAB ? {} : { tab: nextTab }, { replace: true });
  };

  return (
    <ManagementPageLayout
      pageTitle={t('storesManagement.title')}
      pageSubtitle={t('storesManagement.subtitle')}
    >
      <FolderTabs
        tabs={tabs}
        value={activeTab}
        onChange={handleTabChange}
        contentId="stores-management-tabs-content"
        equalWidthOnMobile
      >
        <Box role="tabpanel" hidden={activeTab !== STORES_TAB}>
          {activeTab === STORES_TAB ? <StoresManagementStoresPanel /> : null}
        </Box>
        <Box role="tabpanel" hidden={activeTab !== VOUCHERS_TAB}>
          {activeTab === VOUCHERS_TAB ? <PlanDiscountVouchersPanel /> : null}
        </Box>
      </FolderTabs>
    </ManagementPageLayout>
  );
};

export default StoresManagementPage;
